// Etiqueta del método/modelo a partir del slug del proyecto (o su lenguaje original).
// Fuente única usada por Home y Projects para los chips de modelo.
export const methodLabel = (p) => {
  const s = (p && p.slug) || '';
  if (s.includes('logit-ordinal')) return 'Logit ordinal';
  if (s.includes('multinomial')) return 'Logit multinomial';
  if (s.startsWith('psm-')) return 'PSM';
  if (s.includes('oaxaca')) return 'Oaxaca-Blinder';
  if (s.includes('-logit') || s.endsWith('logit')) return 'Logit';
  if (s.startsWith('did-')) return 'Diff-in-diff';
  if (s.startsWith('rdd-')) return 'Reg. discontinua';
  if (s.includes('efectos-fijos')) return 'Efectos fijos';
  if (s.includes('regresion-multiple')) return 'OLS múltiple';
  if (s.includes('sarima')) return 'SARIMA';
  if (p && p.original_language) {
    return { r: 'R', stata: 'Stata', excel: 'Excel' }[p.original_language] || p.original_language;
  }
  return null;
};

export default methodLabel;
